function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "flag-icon");

var SvgFlagAlt = function SvgFlagAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b9b35faa-8f6c-43d3-8e34-7b576f2e8980",
    "data-name": "Layer 2",
    viewBox: "0 0 441.5 573.38",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M97.42,583.13a12.29,12.29,0,0,1-17.92,0V17.5a12.29,12.29,0,0,1,17.92,0Z",
    transform: "translate(-79.5 -13.63)",
    style: {
      fill: "#e54b4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.92 28.91 441.5 28.19 349.36 186.87 441.5 343 16.64 343 17.92 28.91",
    style: {
      fill: "#e54b4b"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag-alt.64bb1e84.svg";
export { ForwardRef as ReactComponent };